import { BACKEND_URL } from "../../utils/config";
import { errorHandler } from "../../utils/error_handler";
import { getUserPermission } from "../../utils/getUserPermission";


export const setInfoStates = (info_states) => ({
    type: "SET_INFO_STATES",
    payload: {
        info_states: info_states,
    },
    request_time: Date.now()
});

export const setInfoState = (data) => ({
    type: "SET_INFO_STATE",
    payload: {
        id: data.id,
        name: data.name,
        request_time: Date.now()
    },
});

export const setInfoStateError = (error) => ({
    type: "INFO_STATE_ERROR",
    payload: {
        error: error
    }
});

export const deleteInfoState = (info_state_id) => ({
    type: "DELETE_INFO_STATE",
    payload: {
        id: info_state_id,
    },
    request_time: Date.now()
});

export const getAllInfoStates = () => {

    return (dispatch, getState) => {
        const state = getState();
        try {
            if (!getUserPermission(state, "info_states", "list")) {
                throw new Error("No permissions");
            }
            if (state.info_states.request_time === null
                || state.info_states.request_time + 1000 * 2 < Date.now()) {
                fetch(`${BACKEND_URL}/info_states`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${state.sessions.token}`
                    },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            return response.json();
                        } else {
                            throw new Error(response.status);
                        }
                    })
                    .then((data) => {
                        dispatch(setInfoStates(data));
                    })
                    .catch((error) => {
                        errorHandler("info_states", error.message);
                        dispatch(setInfoStateError(error));
                    });
            }
        } catch (error) {
            errorHandler("info_states", error.message);
            dispatch(setInfoStateError(error));
        }
    };
}

export const postInfoState = (data) => {
    return (dispatch, getState) => {
        const state = getState();
        try {
            if (!getUserPermission(state, "info_states", "create", true)) {
                throw new Error("No permissions");
            }
            fetch(`${BACKEND_URL}/info_states`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${state.sessions.token}`
                },
                body: JSON.stringify(data)
            })
                .then((response) => {
                    if (response.status === 201) {
                        return response.json();
                    } else {
                        throw new Error(response.status);
                    }
                })
                .then((data) => {
                    if (data != null && data !== undefined && data.id !== undefined) {
                        dispatch(setInfoState(data));
                    }
                })
                .catch((error) => {
                    errorHandler("info_states", error.message);
                    dispatch(setInfoStateError(error));
                });
        } catch (error) {
            errorHandler("info_states", error.message);
            dispatch(setInfoStateError(error));
        }
    };
}

export const deleteInfoStateById = (info_state_id) => {
    return (dispatch, getState) => {
        const state = getState();
        try {
            if (!getUserPermission(state, "info_states", "delete", true)) {
                throw new Error("No permissions");
            }
            fetch(`${BACKEND_URL}/info_states/${info_state_id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${state.sessions.token}`
                },
            })
                .then((response) => {
                    if (response.status === 204) {
                        return true;
                    } else {
                        throw new Error(response.status);
                    }
                })
                .then((vl) => {
                    if (vl) {
                        dispatch(deleteInfoState(info_state_id));
                    }
                })
                .catch((error) => {
                    errorHandler("info_states", error.message);
                    dispatch(setInfoStateError(error));
                });
        } catch (error) {
            errorHandler("info_states", error.message);
            dispatch(setInfoStateError(error));
        }
    };
}